






























































import { Component, Prop, Mixins, Ref } from "vue-property-decorator";
import VModal from "@/components/VModal.vue";
import { SettingEntry } from "@/models/Setting";
import GeneralSettingsMixin from "@/mixins/http/GeneralSettingsMixin";
import VNumericInput from "@/components/VNumericInput.vue";
import WithErrors from "@/directives/WithErrors";
import { httpStore } from "@/store/typed";

@Component({
  components: {
    VModal,
    VNumericInput,
  },
  directives: { WithErrors },
})
export default class GeneralSettingsCreateModal extends Mixins(
  GeneralSettingsMixin
) {
  @Prop() readonly type!: SettingEntry;
  @Prop({ required: true }) readonly tag!: string;

  @Ref() readonly modal!: VModal;
  content = "";

  private prototype: any = {
    fullName: null,
    shortName: null,
    symbol: null,
    conversion: 1,
  };

  canceled!: Function | null;

  get valid() {
    const baseValid = this.prototype.shortName && this.prototype.fullName;

    if (this.isCurrency) {
      return baseValid && this.prototype.symbol && this.prototype.conversion;
    } else {
      return baseValid;
    }
  }

  get createRequest() {
    return httpStore.status[this.tag];
  }

  get loading() {
    return this.createRequest?.loading;
  }

  title() {
    return `Add ${this.type.name.toLowerCase()}`;
  }

  get isCurrency() {
    return "currencies" === this.type.type;
  }

  get isMeasurementUnit() {
    return "measurementUnits" === this.type.type;
  }

  protected onCancel() {
    if (this.canceled) {
      this.canceled();
    }

    this.canceled = null;
    this.modal.hide();
    this.reset();
  }

  protected onConfirm() {
    this.$emit("confirmed", Object.assign({}, this.prototype));
  }

  protected onHidden() {
    if (this.canceled) {
      this.canceled();
    }
  }

  reset() {
    this.prototype = {
      fullName: null,
      shortName: null,
      symbol: null,
      conversion: null,
    };
  }

  hide() {
    this.modal.hide();
  }

  create() {
    this.modal.show();
  }
}
